import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter-container" }
const _hoisted_2 = { class: "filter-box" }
const _hoisted_3 = { class: "filter-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TableList = _resolveComponent("TableList")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.comment,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
            placeholder: " ",
            style: {"width":"400px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item leaveMessage",
            clearable: ""
          }, null, 8, ["modelValue", "size"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" 留言 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])
        ])
      ]),
      _withDirectives(_createVNode(_component_TableList, {
        ref: "TableList",
        dataList: _ctx.list,
        total: _ctx.total,
        columnAllData: _ctx.columnAllData,
        tableName: _ctx.TableName,
        permissionName: _ctx.permissionName,
        showSelection: false,
        canRefresh: false,
        canChangeColumn: false,
        canCommand: false,
        page: _ctx.listQuery.page,
        size: _ctx.listQuery.size,
        onCommandChange: _ctx.handleCommand
      }, null, 8, ["dataList", "total", "columnAllData", "tableName", "permissionName", "page", "size", "onCommandChange"]), [
        [_directive_loading, _ctx.listLoading]
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ])
  ]))
}